<template>
  <v-toolbar dense flat height="32">
    <slot name="left"></slot>
    <v-tooltip top v-for="barAction of value">
      <template v-slot:activator="{ on, attrs }">
        <v-spacer v-if="barAction.action_name === 'embedded_space'"></v-spacer>
        <v-btn
            v-show="isShow(barAction)"
            v-on="on"
            small
            elevation="2"
            :color="barAction.color"
            dense
            class="mx-1"
            @click="onClick(barAction)"
            :disabled="isDisabled(barAction) || isLoad(barAction)"
        >
          <v-icon :color="barAction.icon_color">{{ barAction.icon }}</v-icon>
          {{ barAction.label }}
          <v-progress-circular
              v-show="isLoad(barAction)"
              indeterminate
              size="16"
              width="1"
              color="blue-grey lighten-1"
              class="ml-1 mr-n2"
          >
          </v-progress-circular>
        </v-btn>
      </template>
      <span v-if="!!barAction.text">{{ barAction.text }}</span>
      <span v-else>{{ barAction.label }}</span>
    </v-tooltip>
    <slot name="right"></slot>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="30%"
    >
      <v-card v-if="!!currentBarAction">
        <v-card-text class="text-h6 py-10 px-10">{{ currentBarAction.confirm_message }}</v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="onSave()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>

import {defineStore} from "pinia";
import {storeToRefs} from 'pinia'

export const useActionStore = function () {
  return defineStore('CommonBtnActionGroup', {
        state: () => ({
              actionsUid: {},
              actionsCallReceive: {},
            }
        ),
      }
  )
}

export default {
  name: 'CommonBtnActionGroup',
  inheritAttrs: false,
  props: {
    value: {default: null},
    disabled: {default: false},
    selectedItems: {
      default() {
        return []
      }
    },
    storeName: {default: 'CommonBtnActionGroup'},
    isNew: {default: false},
    fetchAction: {default: null},
    modalDialog: {default: false},
  },

  components: {},

  computed: {},

  setup({storeName}) {
    // console.log('setup', storeName, uidItem, modalDialog)
    let state = useActionStore(storeName)()
    return {state}
  },

  methods: {
    onSave() {
      this.dialog = false
      this.onAction(this.currentBarAction)
    },
    onClick(barAction) {
      console.log('onClick', this.confirmMessage)
      if (barAction.confirm_message !== null) {
        this.currentBarAction = barAction
        this.dialog = true
        console.log('onClick dialog', this.dialog)
      } else
        this.onAction(barAction)
    },
    onAction(barAction) {
      // console.log('Action event', barAction.action_name, barAction.action_uid)
      if (barAction.action_name.includes('embedded_')) {
        this.$emit(barAction.action_name)
        this.$emit('embedded_action', {actionName: barAction.action_name, actionUid: barAction.action_uid})
        return
      }
      if (barAction.action_name.includes('alternate_')) {
        this.state.actionsUid[barAction.action_uid] = {load: true}
        this.$emit('alternate_action', {actionName: barAction.action_name, actionUid: barAction.action_uid})
        return
      }
      this.$emit('action', {actionName: barAction.action_name, actionUid: barAction.action_uid})
      this.state.actionsUid[barAction.action_uid] = {load: true}
    },
    isShow(barAction) {
      // console.log('isShow', this.isNew)
      return barAction.action_name !== 'embedded_space' && (!barAction.only_modal || this.modalDialog)
    },
    isDisabled(barAction) {
      if ((barAction.disabled || this.disabled) && barAction.action_name !== 'embedded_close')
        return true
      if (barAction.show_only_selected && this.selectedItems.length === 0)
        return true
      return false
    },
    isLoad(barAction) {
      let action_state = this.state.actionsUid[barAction.action_uid]
      if (!!action_state)
        return action_state.load
    },
  },

  async mounted() {
  },

  data() {
    return {
      dialog: false,
      currentBarAction: null,
    }
  }
}
</script>

